import React from 'react';

import { IconButton, Tooltip } from '@vimeo/bokeh';
import { ShoppingCart } from '@vimeo/bokeh-icons';
import { translate } from '@vimeo/i18n-runtime';

import { useTrackNavigationEvent } from '../../tracking';

export const StockCart = ({ itemsCount }: { itemsCount: number | undefined }) => {
  const trackNavigationEvent = useTrackNavigationEvent();
  if (!itemsCount || itemsCount === 0) {
    return <></>;
  }
  return (
    <Tooltip label={translate('Cart')}>
      <IconButton
        aria-label="cart_link"
        icon={<ShoppingCart />}
        as="a"
        href="/store/stock"
        variant="tertiary"
        onClick={() => trackNavigationEvent({ copy: 'cart', element: 'button', feature: 'cart' })}
      />
    </Tooltip>
  );
};
